import 'css-chunksrc/client/scenes/wbs/task/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_19ta9_1",
  "form": "_form_19ta9_6",
  "hovered": "_hovered_19ta9_10",
  "name": "_name_19ta9_1",
  "icon": "_icon_19ta9_13",
  "input": "_input_19ta9_36",
  "edition": "_edition_19ta9_57",
  "editButton": "_editButton_19ta9_64",
  "tooltip": "_tooltip_19ta9_68",
  "constrained": "_constrained_19ta9_88"
};